// import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, OnInit } from '@angular/core';
import { DynamicScriptLoaderService } from 'src/services/dynamic-script-loader.service';
import {
  buildErpPortalAuthUrl,
  clearMootoriSharedBrowserKeys,
  MOOTORI_ERP_SSO_ROUNDTRIP_KEY,
  MOOTORI_PORTAL_SSO_SKIP_ONCE_KEY,
  purgeOtherAppsSessionInBackground
} from 'src/utils/portal-auth.util';

@Component({
  selector: 'app-extra-bar',
  templateUrl: './extra-bar.component.html',
  styleUrls: ['./extra-bar.component.css']
})
export class ExtraBarComponent implements OnInit {
  currentUser: any = null;

  readonly erpLoginUrl = buildErpPortalAuthUrl('login');
  readonly erpRegisterUrl = buildErpPortalAuthUrl('register');

  constructor(private dynamicScriptLoader: DynamicScriptLoaderService/*, private socialAuthService: SocialAuthService*/) {
    this.refreshUser();
  }

  ngOnInit(): void {
    this.refreshUser();
  }

  refreshUser(): void {
    try {
      const raw = localStorage.getItem('user');
      this.currentUser = raw ? JSON.parse(raw) : null;
    } catch {
      this.currentUser = null;
    }
  }

  /**
   * Clears this origin (portal) and triggers the same GMS → ACC → Admin → ERP logout-sync chain
   * in a hidden iframe so other Mootori apps clear their `localStorage` too. The browser stays on
   * the current public URL (no full-page redirect to ERP).
   */
  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('loginby');
    clearMootoriSharedBrowserKeys();
    try {
      sessionStorage.removeItem(MOOTORI_ERP_SSO_ROUNDTRIP_KEY);
      sessionStorage.removeItem('mootori_portal_sso_roundtrip');
      sessionStorage.setItem(MOOTORI_PORTAL_SSO_SKIP_ONCE_KEY, '1');
    } catch {
      /* ignore */
    }
    purgeOtherAppsSessionInBackground();
    this.refreshUser();
  }

  signOut(): void {
    // this.socialAuthService.signOut();
  }
}
